"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("./helpers");

var _styles = _interopRequireDefault(require("./styles"));

var ModalContainer = _styles["default"].ModalContainer,
    Card = _styles["default"].Card,
    TitleContainer = _styles["default"].TitleContainer,
    Title = _styles["default"].Title;

var _default = function _default(props) {
  var _props$setEnabled = props.setEnabled,
      setEnabled = _props$setEnabled === void 0 ? false : _props$setEnabled,
      toggle = props.toggle,
      children = props.children,
      _props$blurBackground = props.blurBackground,
      blurBackground = _props$blurBackground === void 0 ? true : _props$blurBackground,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? true : _props$closeIcon,
      containerClassName = props.containerClassName,
      cardClassName = props.cardClassName,
      title = props.title,
      height = props.height,
      width = props.width,
      maxHeight = props.maxHeight,
      maxWidth = props.maxWidth,
      _props$mattsStyle = props.mattsStyle,
      mattsStyle = _props$mattsStyle === void 0 ? false : _props$mattsStyle,
      setToggle = props.setToggle;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var containerName = 'modal-container ' + containerClassName;
  var cardName = 'modal-card ' + cardClassName;
  (0, _react.useEffect)(function () {
    setLoaded(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (!loaded && setEnabled) {
      setTimeout(function () {
        (0, _helpers.playAnimation)({
          toggle: toggle,
          blurBackground: blurBackground,
          setToggle: setToggle
        });
      }, 500);
    } else if (loaded) (0, _helpers.playAnimation)({
      toggle: toggle,
      blurBackground: blurBackground,
      setToggle: setToggle
    });
  }, [toggle]);
  return /*#__PURE__*/_react["default"].createElement(ModalContainer, {
    className: containerName
  }, /*#__PURE__*/_react["default"].createElement(Card, {
    className: cardName,
    height: height,
    width: width,
    maxHeight: maxHeight,
    maxWidth: maxWidth
  }, /*#__PURE__*/_react["default"].createElement(TitleContainer, null, title && /*#__PURE__*/_react["default"].createElement("h3", null, title), closeIcon && /*#__PURE__*/_react["default"].createElement("i", {
    className: 'fal fa-times ' + (mattsStyle ? 'matts-style' : ''),
    "data-scorpius-automation": 'popupcard-closeicon',
    onClick: function onClick() {
      return setToggle(false);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-children",
    style: {
      display: 'flex'
    }
  }, children)));
};

exports["default"] = _default;